<template>
  <div class="progress">
    <span
      class="progress-bar"
      :style="styleForBar()"
    />
  </div>
</template>

<script>
export default {
  props: {
    color: {
      default: '#4B61EE', // #4B61EE == $blue
      type: String,
    },
  },
  methods: {
    styleForBar() {
      return {
        background: 'linear-gradient(90deg, rgba(0,0,0,0) 40%, ' + this.color + ' 40%, ' + this.color + ' 60%, rgba(0,0,0,0) 60%)',
        backgroundSize: '250% 100%'
      }
    }
  },
}
</script>

<style lang="scss" scoped>
  .progress {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 3px;
    background: $soap;
    z-index: 1001;
    overflow: hidden;

    .progress-bar {
      display: block;
      height: 100%;
      width: 100%;
      animation: progress-animation 1.5s ease infinite;
    }
    @keyframes progress-animation {
      0% {
        background-position: 100%;
      }
      100% {
        background-position: 0;
      }
    }
  }
</style>